module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Sports & Recreation-39df9098d45e0f95a7a27a502dba3c7b.png";